import { render, staticRenderFns } from "./emptyTools.vue?vue&type=template&id=fda520b0&scoped=true"
import script from "./emptyTools.vue?vue&type=script&lang=js"
export * from "./emptyTools.vue?vue&type=script&lang=js"
import style0 from "./emptyTools.vue?vue&type=style&index=0&id=fda520b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda520b0",
  null
  
)

export default component.exports